const initialState = {
  storekeepers: [],
  storekeeper: null,
  selectedStorekeeper: null,
  storekeepersByDepot: [],
  loading: false,
  storekeeperLoading: false,
  storekeepersByDepotLoading: false,
  createLoading: false,
  updateLoading: false,
  deleteLoading: false,
  error: null,
  pageCount: 0,
  total: 0,
};

const storekeeperReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    // Fetch all storekeepers
    case "FETCH_STOREKEEPERS_LOADING":
      return { ...state, loading: true, error: null };

    case "FETCH_STOREKEEPERS_SUCCESS":
      return { 
        ...state, 
        loading: false, 
        storekeepers: payload.data, 
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null 
      };

    case "FETCH_STOREKEEPERS_LOAD_MORE_SUCCESS":
      return {
        ...state,
        loading: false,
        storekeepers: [...state.storekeepers, ...payload.data],
        pageCount: payload.meta?.pagination?.pageCount || 0,
        total: payload.meta?.pagination?.total || 0,
        error: null,
      };

    case "FETCH_STOREKEEPERS_ERROR":
      return { ...state, loading: false, error: payload };

    // Fetch single storekeeper
    case "FETCH_STOREKEEPER_LOADING":
      return { ...state, storekeeperLoading: true, error: null };

    case "FETCH_STOREKEEPER_SUCCESS":
      return { ...state, storekeeperLoading: false, storekeeper: payload, error: null };

    case "FETCH_STOREKEEPER_ERROR":
      return { ...state, storekeeperLoading: false, error: payload };

    // Create storekeeper
    case "CREATE_STOREKEEPER_LOADING":
      return { ...state, createLoading: true, error: null };

    case "CREATE_STOREKEEPER_SUCCESS":
      return {
        ...state,
        createLoading: false,
        storekeepers: [...state.storekeepers, payload],
        storekeeper: payload,
        error: null,
      };

    case "CREATE_STOREKEEPER_ERROR":
      return { ...state, createLoading: false, error: payload };

    // Update storekeeper
    case "UPDATE_STOREKEEPER_LOADING":
      return { ...state, updateLoading: true, error: null };

    case "UPDATE_STOREKEEPER_SUCCESS":
      return {
        ...state,
        updateLoading: false,
        storekeepers: state.storekeepers.map((storekeeper) =>
          storekeeper.id === payload.id ? payload : storekeeper
        ),
        storekeeper: state.storekeeper?.id === payload.id ? payload : state.storekeeper,
        selectedStorekeeper: state.selectedStorekeeper?.id === payload.id ? payload : state.selectedStorekeeper,
        error: null,
      };

    case "UPDATE_STOREKEEPER_ERROR":
      return { ...state, updateLoading: false, error: payload };

    // Delete storekeeper
    case "DELETE_STOREKEEPER_LOADING":
      return { ...state, deleteLoading: true, error: null };

    case "DELETE_STOREKEEPER_SUCCESS":
      return {
        ...state,
        deleteLoading: false,
        storekeepers: state.storekeepers.filter((storekeeper) => storekeeper.id !== payload),
        storekeeper: state.storekeeper?.id === payload ? null : state.storekeeper,
        selectedStorekeeper: state.selectedStorekeeper?.id === payload ? null : state.selectedStorekeeper,
        error: null,
      };

    case "DELETE_STOREKEEPER_ERROR":
      return { ...state, deleteLoading: false, error: payload };

    // Fetch storekeepers by depot
    case "FETCH_STOREKEEPERS_BY_DEPOT_LOADING":
      return { ...state, storekeepersByDepotLoading: true, error: null };

    case "FETCH_STOREKEEPERS_BY_DEPOT_SUCCESS":
      return {
        ...state,
        storekeepersByDepotLoading: false,
        storekeepersByDepot: payload,
        error: null,
      };

    case "FETCH_STOREKEEPERS_BY_DEPOT_ERROR":
      return { ...state, storekeepersByDepotLoading: false, error: payload };


    // Set selected storekeeper
    case "SET_SELECTED_STOREKEEPER":
      return { ...state, selectedStorekeeper: payload };

    // Clear storekeeper data
    case "CLEAR_STOREKEEPER_DATA":
      return {
        ...state,
        storekeeper: null,
        selectedStorekeeper: null,
        storekeepersByDepot: [],
        error: null,
      };

    default:
      return state;
  }
};

export default storekeeperReducer;
